define('casino/casino',['jquery', 'casino/navigation', 'casino/casino-data', 'all/Object'], function($, casinoNavigation, casinoData) {
	'use strict';

	var RECOMMENDED_GAMES_COUNT = 8;
	var NETENT = 3;

	var casino = {};

	/**
	 * @return {number} appropriate for random sort
	 */
	function RANDOM_SORT() {
		return 0.5 - Math.random();
	}

	/**
	 * @param gameId
	 * @returns {Object} game
	 * @throws {ReferenceError} if non-existing game for an id
	 */
	function getGame(gameId) {
		var game = getMatchingGame(gameId);
		if(game) {
			return game;
		}
		console.log('game is undefined for game id ' + gameId);
        return undefined;
	}

	/**
	 * @param gameId
	 * @returns {*} game, or undefined
	 */
	function getMatchingGame(gameId) {
		var gameKey;
		if ($.isNumeric(gameId)) {
			gameKey = 'game=' + gameId;
		} else {
			gameKey = gameId;
		}

		var game = casinoData.games[gameKey];
		if (game) {
			return game;
		}

		var groupKey = casinoData.gamesInGroups[gameKey];
		if (groupKey) {
			return casinoData.games[groupKey].games[gameKey];
		}
	}

	/**
	 *
	 * @param gameIds
	 * @returns {Array} games for game ids
	 * @throws {ReferenceError} if non-existing game for an id in the list
	 */
	function getGames(gameIds) {
		return $.map(gameIds, function(gameId) {
			return getGame(gameId);
		});
	}

	/**
	 *
	 * @param gameIds
	 * @returns {Array} list of matching games for ids, ignoring missing ones
	 */
	function getMatchingGames(gameIds) {
		return $.map(gameIds, function(gameId) {
			return getMatchingGame(gameId); // !== undefined;
		});
	}

	/**
	 * @param {Array} excludeIds list of ids not to return from random list
	 * @returns {String} a random gameId, not in excludeIds, preferring recommended ids first, and respecting providers maxSimultaneousGames setting
	 */
	function getRandomNetentGameId(excludeIds) {
		if(!excludeIds) {
			excludeIds = [];
		}

		if(!$.isArray(excludeIds)) {
			excludeIds = [excludeIds];
		}

		var gameIds = getRecommendedGameIds(excludeIds).sort(RANDOM_SORT);

		var otherGameIds = $.grep(Object.keys(casinoData.games), function(id) {
			return $.inArray(id, excludeIds) === -1 && $.inArray(id, gameIds) === -1;
		}).sort(RANDOM_SORT);

		$.merge(gameIds, otherGameIds);

		for(var i = 0; i < gameIds.length; i++) {
			var gameId = gameIds[i];
			var game = casino.getMatchingGame(gameId);
			if(!game) {
				continue;
			}

			if(game.provider === NETENT) {
				return gameId;
			}
		}

		throw new Error('Could not get random game id from json', casinoData.games, 'excludeIds:', excludeIds);
	}

	/**
	 * @param {Array} excludeIds game ids to exclude from result
	 * @returns {Array} up to 8 random recommended gameIds, not among excludeIds
	 */
	function getRecommendedGameIds(excludeIds) {
		return $.grep(casinoData.recommended, function(id) {
			return $.inArray(id, excludeIds) === -1;
		}).sort(RANDOM_SORT).slice(0, RECOMMENDED_GAMES_COUNT);
	}

	/**
	 * @param {Object} game
	 * @returns {Object} provider for game
	 * @throws {ReferenceError} if no provider for game
	 */
	function getProvider(game) {

		var providerId = game.provider;
		var provider = casinoData.providers[providerId];

		if (provider === undefined) {
			throw new Error('provider is undefined for game id=' + game.id + ' and provider id=' + providerId);
		}

		provider.id = providerId;
		return provider;
	}

	function replaceGameIdInLocationHash(oldGameId, gameId) {
		var re = new RegExp(oldGameId + '\\b');
		location.hash = location.hash.replace(re, gameId);
	}

	// if parent group, return key for group
	function getGroupKeyForGameId(gameId) {
		return casinoData.gamesInGroups[gameId];
	}

	function getLocation() {
		return casinoData.location;
	}

	casino.getGame = getGame;
	casino.getGames = getGames;
	casino.getMatchingGame = getMatchingGame;
	casino.getMatchingGames = getMatchingGames;
	casino.getRandomNetentGameId = getRandomNetentGameId;

	casino.getGroupKeyForGameId = getGroupKeyForGameId;

	casino.getRecommendedGameIds = getRecommendedGameIds;

	casino.getProvider = getProvider;

	casino.replaceGameIdInLocationHash = replaceGameIdInLocationHash;

	casino.getLocation = getLocation;

	return casino;
});

